import React, { FC } from "react";
import { SvgIcon } from "../../SvgIcon/SvgIcon";
import { useBookingContext } from "../../BookingButton/BookingContext/BookingContext";

import classNames from "classnames";

import { isLocationSelected } from "../Helpers/locationHelpers";

import { LocationDto } from "@apiModels/LocationDto.csharp";

interface BookingSearchInputProps {
  searchValue: string;
  setSearchValue: (value: string) => void;
  location: LocationDto;
}

export const BookingSearchInput: FC<BookingSearchInputProps> = ({
  searchValue,
  setSearchValue,
  location,
}) => {
  const { bookingSearchSetup } = useBookingContext();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const clearInput = () => {
    setSearchValue("");
  };

  const labelText =
    bookingSearchSetup?.inputPlaceholder ??
    "Søk etter tjeneste eller behandler";

  return (
    <div className="BookingSearch">
      <label htmlFor="BookingSearch__input" className="BookingSearch__label">
        {labelText}
      </label>

      <div className="BookingSearch__input-wrapper">
        <input
          type="text"
          id="BookingSearch__input"
          className="BookingSearch__input"
          placeholder={labelText}
          value={searchValue}
          onChange={handleInputChange}
        />

        <span
          className={classNames("BookingSearch__icon-wrapper", {
            "BookingSearch__icon-wrapper--active": searchValue,
          })}
          onClick={searchValue ? clearInput : undefined}
        >
          <SvgIcon
            iconName={searchValue ? "s-close" : "s-search"}
            className={classNames("BookingSearch__icon", {
              "BookingSearch__icon--active": searchValue,
            })}
          />
        </span>
      </div>
    </div>
  );
};
